var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Identity from './identity';
/** A simple identity provider for working with Json Web Tokens. */
var JWTProvider = /** @class */ (function () {
    function JWTProvider(serviceName, store, refreshCallback, refreshWindow) {
        if (refreshWindow === void 0) { refreshWindow = 300; }
        this.serviceName = serviceName;
        this.store = store;
        this.refreshCallback = refreshCallback;
        this.refreshWindow = refreshWindow;
        this.identity = new Identity(null, null);
    }
    JWTProvider.prototype.getIdentity = function () {
        return __awaiter(this, void 0, void 0, function () {
            var storedIdentity;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.identity.isAuthenticated) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getStoredIdentity()];
                    case 1:
                        storedIdentity = _a.sent();
                        this.identity = storedIdentity;
                        _a.label = 2;
                    case 2:
                        if (!!this.identity.isAuthenticated) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshIdentity()];
                    case 3:
                        _a.sent();
                        if (!this.identity.isAuthenticated) {
                            // Empty identity
                            return [2 /*return*/, this.identity];
                        }
                        _a.label = 4;
                    case 4:
                        if (!this.isExpired()) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.refreshIdentity()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/, this.identity];
                }
            });
        });
    };
    JWTProvider.prototype.update = function (identity, credentials, store) {
        if (store === void 0) { store = true; }
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.identity = this.intoIdentity(identity, credentials);
                if (store) {
                    this.store.store(this.serviceName, { identity: identity, credentials: credentials });
                }
                return [2 /*return*/, this.identity];
            });
        });
    };
    JWTProvider.prototype.clear = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.identity = new Identity(null, null);
                this.store.store(this.serviceName, { identity: null, credentials: null });
                return [2 /*return*/];
            });
        });
    };
    JWTProvider.prototype.getStoredIdentity = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, identity, credentials, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.store.fetch(this.serviceName)];
                    case 1:
                        _a = _b.sent(), identity = _a.identity, credentials = _a.credentials;
                        return [2 /*return*/, this.intoIdentity(identity, credentials)];
                    case 2:
                        e_1 = _b.sent();
                        return [2 /*return*/, this.intoIdentity(null, null)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    JWTProvider.prototype.refreshIdentity = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, identity, credentials;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.refreshCallback) {
                            this.identity = new Identity(null, null);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.refreshCallback()];
                    case 1:
                        _a = _b.sent(), identity = _a.identity, credentials = _a.credentials;
                        if (!identity) {
                            this.clear();
                        }
                        this.update(identity, credentials);
                        return [2 /*return*/];
                }
            });
        });
    };
    JWTProvider.prototype.isExpired = function () {
        // Get the body of the JWT.
        if (!this.identity.credentials) {
            return true;
        }
        var payload = this.identity.credentials.jwt.split('.')[1];
        // Which is base64 encoded.
        var parsed = JSON.parse(atob(payload));
        var expiredTime = Math.floor(Date.now() / 1000) + this.refreshWindow;
        return parsed.exp < expiredTime;
    };
    JWTProvider.prototype.intoIdentity = function (identityName, credentials) {
        var ids = new Map();
        ids.set('sub', this.extractSub(credentials));
        return new Identity(identityName, credentials, ids);
    };
    JWTProvider.prototype.extractSub = function (credentials) {
        if (!credentials) {
            return undefined;
        }
        var payload = credentials.jwt.split('.')[1];
        var parsed = JSON.parse(atob(payload));
        return parsed.sub;
    };
    return JWTProvider;
}());
export default JWTProvider;
//# sourceMappingURL=jwt.js.map